import Head from "next/head";
import Vision from "../../components/about_us/Vision";
import WMAD_banner from "../../components/about_us/WMAD_banner";
import Testamonials from "../../components/about_us/Testamonials";
import Team from "../../components/about_us/Team";
import Contact_us from "../../components/contact_us";
import Page_name from "../../components/pagename/";

import Header from "../../components/about_us/Header";
import Play_button from "../../components/about_us/Play_button";
import axios from "../../Axios";
import { useTranslations } from "next-intl";
import ScrollAnimation from "../../components/homepage/scrollAnimatin/ScrollAnimation.js";
const About_us = ({ allTestimonials, allTeam }) => {
  const t = useTranslations("aboutUs");
  return (
    <div className="overflow-hidden">
      <Head>
        <title>About Us | Ascot Enterprise Solutions</title>
      </Head>
      <Page_name title={t("pageName")} img={"about-us/User"} />
      <Header />
      <Play_button />
      <Vision />
      <WMAD_banner />
      <ScrollAnimation />
      <div className="mt-[47px] relative ">
        {/* <Testamonials testamonials={allTestimonials} /> */}
        <Team allTeam={allTeam} />
      </div>
      <Contact_us />
    </div>
  );
};

export default About_us;

export async function getServerSideProps({ locale }) {
  try {
    const testimonial = await axios.get(
      `${process.env.NEXT_APP_BACKEND_URL}user/testimonials/all_testimonials/${locale}`
    );

    const team = await axios.get(
      `${process.env.NEXT_APP_BACKEND_URL}user/team/limit`,
      {
        data: { lang: locale },
      }
    );

    const allTestimonials = testimonial.data.result;
    const allTeam = team.data.result;
    return {
      props: {
        allTestimonials,
        allTeam,
        messages: require(`../../locales/${locale || "en"}.json`),
      },
    };
  } catch (error) {
    return { props: { blogData: false } };
  }
}
